import * as React from "react";
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import {Policy, productHelper, ProductsEnum} from "@falcon/services";
import { hasActiveMotorPolicy, scrollToTop } from "../../CommonFunctions";
import {IWithRouterProps, withRouter} from "@athena-portal/components";

interface IProps {
    product: string;
    policies?: Policy[];
    policy?: Policy;
}

interface IState {
    showModal?: boolean;
}

export class NewQuoteModalPopUpPlain extends React.Component<IProps & IWithRouterProps, IState> {

    constructor(props: IProps & IWithRouterProps) {
        super(props);

        this.state = {
            showModal: false
        };
    }

    public componentDidMount() {
        this.setState({
            showModal: true
        });
    }

    public render() {
        const selectedProduct = this.props.product;
        const selectedProductName = selectedProduct === ProductsEnum.WOLF_MOTOR ? "car" : "home";
        const hasActivePolicy = productHelper.atLeastOneActivePolicy(this.props.policies || [this.props.policy!]);

        return (
            <Modal className="custom-info-modal" isOpen={this.state.showModal} id="getNewQuoteModal">
                <ModalHeader>
                    <div className="d-flex">
                        <img src="/img/Flow-info-selected.svg" alt="Info icon"/>
                        <span
                            className="ml-3 text-blue-2 fs-20 font-weight-medium">Before getting a quote for a new {selectedProductName} policy...</span>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-0">
                    {this.getModalBody(selectedProduct, hasActivePolicy)}
                </ModalBody>
                <ModalFooter className="my-2 w-100">
                    <button type="button" className="btn btn-primary btn-next-no-arrow w-100" onClick={this.navigateToNewQuotePage(hasActivePolicy)}
                            id="accept-btn">Ok, I understand
                    </button>
                </ModalFooter>
            </Modal>
        );
    }

    // Adding Sonar ignore as typescript:S2301 rule should be disabled in analysis
    private getModalBody(selectedProduct: string, hasActivePolicy: boolean) { // NOSONAR
        if (selectedProduct === ProductsEnum.WOLF_MOTOR && hasActivePolicy) { // NOSONAR
            return (<>
                <p className="font-weight-semi-bold">Your existing account details will be used to create a new policy
                    for your vehicle.<br/>The new policy will have:</p>
                <p className="font-weight-extra-light">● The same email address as the existing policy</p>
                <p className="font-weight-extra-light">● The same policyholder as the existing policy</p>
                <p className="font-weight-extra-light">● The same address as the existing policy</p>
                <p className="font-weight-extra-light">You'll use your existing account to access and manage this new
                    policy. If any information is incorrect
                    or needs updating, please update your existing policy before continuing</p>
                <p className="font-weight-extra-light">Alternatively, to set up a policy with a different policyholder,
                    please <a href={"https://www.allianz.co.uk/insurance/car-insurance.html"}>start a new quote</a></p>
            </>);
        } else if (!hasActivePolicy || selectedProduct === ProductsEnum.WOLF_MOTOR) { // NOSONAR
            return (<>
                <p className="font-weight-semi-bold">To get new policies in the existing account please check the
                    following:</p>
                <p className="font-weight-extra-light">● The new policy use the same email address as the existing
                    policy;</p>
                <p className="font-weight-extra-light">● The policyholder must have the same name and date of birth as
                    on the existing policy;</p>
                <p className="font-weight-extra-light">● The policyholder must live at the same address as on the
                    existing policy.</p>
            </>);
        } else {
            return (<>
                <p className="font-weight-semi-bold">Your existing account details will be used to create a new policy
                    for your home.<br/>The new policy will have:</p>
                <p className="font-weight-extra-light">● The same email address as the existing policy</p>
                <p className="font-weight-extra-light">● The same policyholder as the existing policy</p>
                <p className="font-weight-extra-light">● The same address as the existing policy</p>
                <p className="font-weight-extra-light">You'll use your existing account to access and manage this new
                    policy. If any information is incorrect
                    or needs updating, please update your existing policy before continuing</p>
            </>);
        }
    }

    private navigateToNewQuotePage(hasActivePolicy: boolean) {
        const hasActiveCarPolicy = hasActiveMotorPolicy(this.props.policies || [this.props.policy!]);

        if (hasActivePolicy && this.props.product === ProductsEnum.HOME) {
            return () => {
                this.props.navigate(`/journey/show/product/${ProductsEnum.HOME}/process/nb/quickQuotePresetPage`, {state: this.props.policy});
                scrollToTop();
            }
        } else if (this.props.product === ProductsEnum.HOME) {
            return () => this.props.navigate(`/journey/show/product/${ProductsEnum.HOME}/process/nb/dashboardEntryPage`);
        }

        if (hasActiveCarPolicy && this.props.product === ProductsEnum.WOLF_MOTOR) {
            return () => this.props.navigate(`/journey/show/product/${ProductsEnum.WOLF_MOTOR}/process/nb/dashboardEntryPage`);
        } else { // new prefilled Motor quote should be available later for Home
            return () => this.props.navigate(`/journey/show/product/AnnualMotorInsurance/process/nb`);
        }
    }
}

export const NewQuoteModalPopUp = withRouter<IProps>(NewQuoteModalPopUpPlain)
